export const overviewTileTypes = [
  'Tile::GuildMessage',
  'Tile::RaidProgress',
  'Tile::TeamDescription',
  'Tile::RosterSummary',
  'Tile::CustomLinks',
  'Tile::CustomImage',
  'Tile::CustomText',
  'Tile::SidebarTiles',
  'Tile::UpcomingEvents',
  'Tile::RecentEvents',
  'Tile::RecentNews',
  'Tile::EnchantAudit',
  'Tile::PendingApplicants',
  'Tile::OverviewTable',
] as const

export const skeletonHeightByTileType: Record<OverviewTileType, string> = {
  'Tile::GuildMessage': 'h-[4rem]',
  'Tile::RaidProgress': 'h-[4.1rem]',
  'Tile::TeamDescription': 'h-[4rem]',
  'Tile::RosterSummary': 'h-[10rem]',
  'Tile::CustomLinks': 'h-[6rem]',
  'Tile::CustomImage': 'h-[13rem]',
  'Tile::CustomText': 'h-[5rem]',
  'Tile::SidebarTiles': 'h-[19rem]',
  'Tile::UpcomingEvents': 'h-[15rem]',
  'Tile::RecentEvents': 'h-[15rem]',
  'Tile::RecentNews': 'h-[10rem]',
  'Tile::EnchantAudit': 'h-[15rem]',
  'Tile::PendingApplicants': 'h-[10rem]',
  'Tile::OverviewTable': 'h-[25rem]',
}

type OverviewTileType = typeof overviewTileTypes[number]
export default OverviewTileType
